
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section
          className="relative py-32 bg-cover bg-center bg-no-repeat animated-sky-bg"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/cf105a7c52ef5d30950c537f2e72b19c.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-blue-900/30 floating-overlay"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">会社概要</h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto whitespace-nowrap">
              信頼をカタチにする地域密着型企業として、建物に関するあらゆる課題にお応えします
            </p>
          </div>
        </section>
        {/* Company Info */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  株式会社MKファシリティーズについて
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  私たちは埼玉県さいたま市を拠点とする地域密着型企業として、建物に関するあらゆる課題に最適なソリューションを提供しています。
                  お客様の大切な資産である建物を、長期にわたってサポートし続けることが私たちの使命です。
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  経営理念「Reason To Believe」のもと、お客様・グループ・パートナーの三方良しを実現し、持続可能な価値創造を追求しています。
                </p>
              </div>
              <div>
                <img 
                  src="https://static.readdy.ai/image/a106c164b1cd9064ddc9bc406a739a75/1f3707f29fb431378fb56fd6e3adb312.png"
                  alt="会社外観"
                  className="w-full rounded-xl shadow-lg object-cover object-top"
                />
              </div>
            </div>

            {/* Company Details */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">会社情報</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-building-line text-blue-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">会社名</dt>
                      <dd className="text-gray-700">株式会社MKファシリティーズ</dd>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-map-pin-line text-green-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">所在地</dt>
                      <dd className="text-gray-700">〒339-0057　埼玉県さいたま市岩槻区本町1丁目5-4　松永ビル5F</dd>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-orange-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-briefcase-line text-orange-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">事業内容</dt>
                      <dd className="text-gray-700">
                        リノベーション事業<br />
                        FM・メンテナンス事業<br />
                        コンサルティング事業
                      </dd>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-phone-line text-purple-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">電話番号</dt>
                      <dd className="text-gray-700">048-796-8337</dd>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-cyan-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-mail-line text-cyan-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">メールアドレス</dt>
                      <dd className="text-gray-700">masuno@mkf23.com</dd>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="bg-red-100 p-2 rounded-lg flex-shrink-0">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-heart-line text-red-600"></i>
                      </div>
                    </div>
                    <div>
                      <dt className="font-semibold text-gray-900 mb-1">経営理念</dt>
                      <dd className="text-gray-700">Reason To Believe</dd>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Strengths Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                私たちの強み
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                地域密着型企業として培った経験と信頼関係が、私たちの最大の強みです
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-community-line text-blue-600 text-2xl"></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">地域密着</h3>
                <p className="text-gray-600 leading-relaxed">
                  埼玉県を拠点に、地域の特性を深く理解し、お客様に最適なサービスを提供します。
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-tools-line text-green-600 text-2xl"></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">専門技術</h3>
                <p className="text-gray-600 leading-relaxed">
                  豊富な経験と最新の技術で、建物に関するあらゆる課題に対応します。
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-customer-service-line text-orange-600 text-2xl"></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">総合サポート</h3>
                <p className="text-gray-600 leading-relaxed">
                  設計から施工、メンテナンスまで、建物のライフサイクル全体をサポートします。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">アクセス</h2>
              <p className="text-lg text-gray-600 mb-2">
                〒339-0057　埼玉県さいたま市岩槻区本町1丁目5-4　松永ビル5F
              </p>
              <div className="flex items-center justify-center space-x-6 text-sm text-gray-500 mb-8">
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-train-line text-blue-600"></i>
                  </div>
                  <span>東武野田線 岩槻駅より徒歩5分</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-car-line text-green-600"></i>
                  </div>
                  <span>駐車場完備</span>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-100 rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3235.8234567890123!2d139.6934567890123!3d35.9467890123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e7b2345f6789%3A0x1234567890abcdef!2z44CSMzM5LTAwNTcg5Z2457OJ55yM44GV44GE44Gf44G-5biC5bKp5qeL5Yy65pys55S677yR5LiB55uu77yV4oiS77yUIOadvuawuOODk-ODqw!5e0!3m2!1sja!2sjp!4v1703123456789!5m2!1sja!2sjp"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="株式会社MKファシリティーズ 本社所在地"
              ></iframe>
            </div>
            
            <div className="mt-8 bg-blue-50 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">交通アクセス</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-3">
                  <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-train-line text-blue-600"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">電車でお越しの場合</h4>
                    <p className="text-gray-600 text-sm">東武野田線「岩槻駅」東口より徒歩約5分</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="bg-green-100 p-2 rounded-lg flex-shrink-0">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-car-line text-green-600"></i>
                    </div>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">お車でお越しの場合</h4>
                    <p className="text-gray-600 text-sm">東北自動車道「岩槻IC」より約10分<br />駐車場をご用意しております</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
